export function getFontWeightOptions() {

  const options = [
    { name: 'Thin', value: 100 },
    { name: 'Extra Light (Ultra Light)', value: 200 },
    { name: 'Light', value: 300 },
    { name: 'Normal', value: 400 },
    { name: 'Medium', value: 500 },
    { name: 'Semi Bold (Demi Bold)', value: 600 },
    { name: 'Bold', value: 700 },
    { name: 'Extra Bold (Ultra Bold)', value: 800 },
    { name: 'Black (Heavy)', value: 900 }
  ];

  return options;
};